import { RAGE_RIGHT } from "../utils/enums";

export default {
  currentRight: [],

  setCurrentRight(newCurrentRight) {
    //init right array for new rights
    this.currentRight = [];
    //assign new rights
    Array.prototype.push.apply(this.currentRight, newCurrentRight);
  },

  isAdmin() {
    return this.currentRight.includes(RAGE_RIGHT.RAGE_ADMIN);
  },

  isBerater() {
    return this.currentRight.includes(RAGE_RIGHT.RAGE_BERATER_EINS) || this.currentRight.includes(RAGE_RIGHT.RAGE_BERATER_ZWEI);
  },

  isBerater1() {
    return this.currentRight.includes(RAGE_RIGHT.RAGE_BERATER_EINS);
  },

  isBerater2() {
    return this.currentRight.includes(RAGE_RIGHT.RAGE_BERATER_ZWEI);
  },

  isDeubaCallcenter() {
    return this.currentRight.includes(RAGE_RIGHT.RAGE_DEUBA_CALLCENTER);
  },

  isVerseNeoServicecenter() {
    return this.currentRight.includes(RAGE_RIGHT.VERSENEO_SERVICECENTER);
  },

  isEmpty() {
    return this.currentRight == null || this.currentRight.length === 0;
  }
};
